import clsx from 'clsx';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormValue, Type } from '../type';
import { QuickTrade } from './quick-trade';

export function LiteMode() {
  const { control, setValue } = useFormContext<FormValue>();

  const type = useWatch({ control, name: 'type' });

  return (
    <div className="border-t border-t-[#1C1C1C] -mx-4 pt-4 px-4">
      <div className="grid grid-cols-2 bg-[#141414] rounded-xl mb-2">
        <button
          className={clsx(
            'h-10 px-4 rounded-xl border border-transparent transition-all',
            {
              '!border-[#38F24A]': type === Type.Long,
            }
          )}
          onClick={() => setValue('type', Type.Long)}
        >
          <span className="text-sm text-[#38F24A]">Long</span>
        </button>

        <button
          className={clsx(
            'h-10 px-4 rounded-xl border border-transparent transition-all',
            {
              '!border-red1': type === Type.Short,
            }
          )}
          onClick={() => setValue('type', Type.Short)}
        >
          <span className="text-sm text-red1">Short</span>
        </button>
      </div>

      <QuickTrade />
    </div>
  );
}
